import { render } from "./ModalViewGroup.vue?vue&type=template&id=3345b85e"
import script from "./ModalViewGroup.vue?vue&type=script&lang=js"
export * from "./ModalViewGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__